import { render, staticRenderFns } from "./Trace.vue?vue&type=template&id=1029befb&scoped=true&"
import script from "./Trace.vue?vue&type=script&lang=js&"
export * from "./Trace.vue?vue&type=script&lang=js&"
import style0 from "./Trace.vue?vue&type=style&index=0&id=1029befb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1029befb",
  null
  
)

export default component.exports